import {Component, EventEmitter, Input, Output} from '@angular/core';
import {add, endOfMonth, format, sub} from 'date-fns';
import {YuDatetimeModal} from '../../yu-datetime/yu-datetime.component';
import {ModalController} from '@ionic/angular';
import {PresentationTypeEnum} from '../../../../Shared/Enum/presentation-type.enum';
import {AnimationsManagerService} from '../../../../Services/Platform/Ionic/animations-manager.service';
import {HapticsImpactManagerService} from '../../../../Services/Platform/Capacitor/haptics-impact-manager.service';

@Component({
  selector: 'app-month-slider',
  templateUrl: './month-slider.component.html',
  styleUrls: ['./month-slider.component.scss'],
  standalone: false
})
export class MonthSliderComponent {

  @Input() fromDate: string = '';
  @Output() fromDateChange: EventEmitter<string> = new EventEmitter<string>;

  @Input() toDate: string = '';
  @Output() toDateChange: EventEmitter<string> = new EventEmitter<string>;

  @Output() dateChange: EventEmitter<boolean> = new EventEmitter<boolean>;

  constructor(
    protected modalCtrl: ModalController,
    protected animationsService: AnimationsManagerService,
    protected hapticsImpactManager: HapticsImpactManagerService,
  ) {
  }


  /**
   * Ir al siguiente mes
   *
   */
  public addMonth() {
    this.hapticsImpactManager.hapticsImpactMedium();

    this.fromDate = format(add(this.fromDate, {months: 1}), 'yyyy-MM-dd');
    this.setDateToFilter();
  }


  /**
   * Ir al anterior mes
   *
   */
  public subtractMonth() {
    this.hapticsImpactManager.hapticsImpactMedium();

    this.fromDate = format(sub(this.fromDate, {months: 1}), 'yyyy-MM-dd');
    this.setDateToFilter();
  }


  /**
   * Abrir modal para seleccionar el mes
   *
   */
  async openModalMonth() {
    await this.hapticsImpactManager.hapticsImpactHeavy();

    const modal = await this.modalCtrl.create({
      component: YuDatetimeModal,
      enterAnimation: this.animationsService.showModalAnimation,
      leaveAnimation: this.animationsService.hideModalAnimation,
      componentProps: {
        cancelText: '',
        dateValue: this.fromDate,
        presentation: PresentationTypeEnum.MonthYear,
      },
      cssClass: 'transparent-modal',
    });

    modal.onDidDismiss().then((data) => {
      if (data.data) {
        this.fromDate = data.data;
        this.setDateToFilter();
      }
    });

    await modal.present();
  }


  /**
   * Establecer fecha para filtrar
   *
   */
  setDateToFilter() {
    this.toDate = format(endOfMonth(this.fromDate), 'yyyy-MM-dd');

    this.fromDateChange.emit(this.fromDate);
    this.toDateChange.emit(this.toDate);
    this.dateChange.emit(true);
  }

}
